import React, { Fragment, useState } from "react";

import axios from "axios";

import { Container, Row, Col, Card } from "reactstrap";

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

import { LOGIN } from '../../config/config.js';
import logo from '../../images/logo.svg';
import "./Login.css";

const Login = props => {

  const [values, setValues] = useState({ password: "", email: "" });
  const [loading, setLoad] = useState(false);
  const [err, setErr] = useState('');

  const handleOnChange = prop => event => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); setLoad(true);

    if(values.email.length>1 && validateEmail(values.email)===true && values.password.length>=8){
      axios({
        method: 'post',
        url: LOGIN,
        data: {
          EMAIL: values.email,
          PASSWORD: values.password,
          deviceType: "web"
        },
        headers: { 'isToken': false }
      })
      .then(res => {
        if (res.data) {
          setLoad(false); setErr('');
          sessionStorage.setItem('userId', res.data.data.USER_DATA.FIRST_NAME +' '+ res.data.data.USER_DATA.LAST_NAME);
          sessionStorage.setItem('token', res.data.token);
          sessionStorage.setItem('roleJson', JSON.stringify(res.data.data.ROLE_JSON));
          sessionStorage.setItem('id', res.data.data.ID);
          props.history.push('/home');
        } else {
          setLoad(false);
          setErr(res.data.message);
        }
      })
      .catch(error => {
        setLoad(false)
        setErr(error.message);
      })
    } else {
      if(values.email.length===0 && values.password.length>=8) {
        setErr('Please Enter Valid Email');
      } else if(values.email.length>1 && values.password.length<8) {
        setErr('Please Enter Valid Password');
      } else if(values.email.length===0 && values.password.length===0) {
        setErr('Please Enter User Credentials');
      } else if( validateEmail(values.email)===false) {
        setErr('Please Enter Valid Email');
      }

      setLoad(false);
    }
  };

  const onEntered = (e) => {
    if(e.key === 'Enter'){
      setLoad(true);

      if(values.email.length>1 && validateEmail(values.email)===true && values.password.length>=8){
        axios({
          method: 'post',
          url: LOGIN,
          data: {
            EMAIL: values.email,
            PASSWORD: values.password,
            deviceType: "web"
          },
          headers: { 'isToken': false }
        })
        .then(res => {
          if (res.data) {
            setLoad(false); setErr('');
            sessionStorage.setItem('userId', res.data.data.USER_DATA.FIRST_NAME +' '+ res.data.data.USER_DATA.LAST_NAME);
            sessionStorage.setItem('token', res.data.token);
            sessionStorage.setItem('roleJson', JSON.stringify(res.data.data.ROLE_JSON));
            sessionStorage.setItem('id', res.data.data.ID);
            props.history.push('/home');
          } else {
            setLoad(false);
            setErr(res.data.message);
          }
        })
        .catch(error => {
          setLoad(false)
          setErr(error.message);
        })
      } else {
        if(values.email.length===0 && values.password.length>=8) {
          setErr('Please Enter Valid Email');
        } else if(values.email.length>1 && values.password.length<8) {
          setErr('Please Enter Valid Password');
        } else if(values.email.length===0 && values.password.length===0) {
          setErr('Please Enter User Credentials');
        } else if( validateEmail(values.email)===false) {
          setErr('Please Enter Valid Email');
        }
  
        setLoad(false);
      }
    }
  };

  return (
    <Fragment>
      <div className=" login-bg">&nbsp;</div>

      <div className="login-page">
        <div className="col-sm-6 col-md-8 col-lg-6 login-card">
          <Card className="py-4 login-card">
            <div style={{textAlign: 'center'}} className="mb-2">
              <img src={logo} className="logo" alt="logo" />
            </div>

            <h1 style={{ 
              textAlign: "center", 
              fontSize: "1.5625rem", 
              fontWeight: "500", 
              fontFamily: "Futura", 
              color: "#338D7E" 
            }}>
              {err==='' ? 'Login' : <span style={{color: 'red', fontSize: '16px', fontWeight: 'bold'}}>{err}</span>}
            </h1>

            <form className="mt-4 text-center" onSubmit={handleSubmit} onKeyDown={onEntered}>
              <Container>
                <Row>
                  <Col xs={12} sm={12} className='py-2 px-2'>
                    <InputText 
                      className="p-inputtext-login p-username-login"
                      value={values.email}
                      onChange={handleOnChange("email")}
                      placeholder='Enter User Name'
                      disabled={loading} required
                    />
                  </Col>

                  <Col xs={12} sm={12} className='py-2 px-2'>
                    <div class="p-password-login ">
                      <Password 
                        className="p-inputtext-login "
                        value={values.password}
                        placeholder='Enter Password'
                        onChange={handleOnChange("password")}
                        toggleMask 
                        feedback={false}
                        type= "password"
                        disabled={loading} required
                      />
                    </div>
                  </Col>

                  <Col xs={12} sm={12} className='py-2 px-2'>
                    <Button
                      label='LOGIN'
                      style={{
                        width: "280px",
                        height: "35px",
                      }}
                      loading={loading}
                      disabled={loading}
                      onClick={handleSubmit}
                    /> 
                  </Col>
                </Row>
              </Container>
            </form>
          </Card>
        </div>
      </div>
    </Fragment>
  );
}

export default Login;